/**
 * ESTABLISHMENT FORM MODAL
 * Edit general informations for the establishment
 */
import Space from "@/components/space"
import { t } from "i18next"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import establishmentStore from "../../model/establishment.store"
import TextInput from "@/components/text-input"
import Modal from "@/components/modal"
import Button from "@/components/button"
import { faSave, faTimes } from "@fortawesome/free-solid-svg-icons"

interface Props {
  isNew?: boolean
  status: string
  onSave?: () => void
  onClose: () => void
}

export default function EstablishmentFormModal({ isNew, status, onSave, onClose }: Props) {
  const dispatch = useAppDispatch()
  const draft = useAppSelector(establishmentStore.selectors.draft)

  const update =
    (key: "name" | "establishmentId" | "address" | "industryCode") =>
    ({ value }) => {
      dispatch(establishmentStore.actions.edit({ key, value }))
    }

  return (
    <Modal
      isLarge
      disableOverflow
      status={status}
      title={isNew ? "Ajouter un établissement" : "Modifier un établissement"}
      footer={
        <div className="flex w-full m-[-5px] mt-20">
          <Space />
          <Button onClick={onClose} className="med" icon={faTimes} isWithBorder>
            {t("utils_close")}
          </Button>
          <Button onClick={onSave} className="primary" icon={faSave}>
            {t("utils_save")}
          </Button>
        </div>
      }>
      <div className="flex flex-col">
        <div className="flex gap-4">
          <TextInput title={t("Nom de l'établissement")} value={draft.name} onChange={update("name")} />
          <TextInput title={t("Numéro SIRET")} value={draft.establishmentId} onChange={update("establishmentId")} />
          <TextInput title={t("Code NAF")} value={draft.industryCode} onChange={update("industryCode")} />
        </div>

        <div className="flex flex-col">
          <div className="text-input-title flex grey-t">{t("Adresse")}</div>
          <textarea
            placeholder="ex: 14 Rue Eugène Freyssinet&#10;75013 Paris"
            className="text-area"
            value={draft.address || ""}
            onChange={(e) => update("address")({ value: e.target.value })}
            rows={4}
          />
        </div>
      </div>
    </Modal>
  )
}
